<template>
<footer>
  <div class="basic-footer text-center ptb-90">
    <div class="container">
      <div class="footer-logo mb-30">
        <img src="/images/logo.png" alt="logo">
      </div>
      <div class="social-icon">
        <a href="https://www.linkedin.com/in/englishx89/" title="LinkedIn"><i class="ion-social-linkedin"></i></a>
        <a href="mailto:hello@fredericka.me" title="e-mail me"><i class="ion-android-mail"></i></a>
        <a href="#" v-scroll-to="'#app'" title="Scroll Top"><i class="ion-arrow-up-c"></i></a>
      </div>
      <div class="footer-menu mt-30">
        <nav>
          <ul>
            <li v-for="(link, text) in navigation" v-bind:key="text">
              <router-link :to="link">{{text}}</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: "Footer",
  props: ["navigation"]
}
</script>